import React from 'react';
import './App.css';
import RouterComponent from './components/RouterComponent/RouterComponent';

function App() {
  return (
    <div className="wrapper">
      <RouterComponent />
    </div>
  );
}

export default App;
